__turbopack_context__.v({
  "description": "lNLdJa_description",
  "destinationInformation": "lNLdJa_destinationInformation",
  "imageWrapper": "lNLdJa_imageWrapper",
  "mediaColumn": "lNLdJa_mediaColumn",
  "textTruncate": "lNLdJa_textTruncate",
});
